export default {
  namespaced: true,
  state: {
    items: [],
    types: [{
      value: "calibration",
      text: "Contrôle règlementaire"
    },
    {
      value: "repair",
      text: "Réparation"
    }
    ]
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'externalmaintenance',
        api_data_path: 'externalMaintenances',
        namespace: 'external_maintenance'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'externalmaintenance/index/simple',
        api_data_path: 'externalMaintenances',
        namespace: 'external_maintenance'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge les dernières maintenances externes : liste d'amorçage de l'autocomplete, pour
     * qu'ouvrir le champ propose quelque chose avant la première frappe.
     * @param   {boolean} wait   Si wait = true, on attend la réponse avant le resolve()
     * @param   {integer} limit  Nombre de maintenances à charger
     * @param   {boolean} add    true pour compléter le state au lieu de le remplacer
     * @returns {promise}        Réponse de l'API
     */
    getLastForSelect: (context, { wait = false, limit = 20, add = true }) => {
      let params = {
        wait: wait,
        api_url: 'externalmaintenance/index/simple',
        api_data_path: 'externalMaintenances',
        namespace: 'external_maintenance',
        limit: limit,
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge les maintenances externes correspondant à une recherche : la table dépasse
     * 100 000 lignes, on ne la charge jamais en entier pour alimenter un autocomplete.
     * @param   {boolean} wait    Si wait = true, on attend la réponse avant le resolve()
     * @param   {string}  search  Expression recherchée (numéro de maintenance)
     * @param   {boolean} add     true pour compléter le state au lieu de le remplacer
     * @returns {promise}
     */
    getAllForSelectBySearch: (context, { wait = false, search, add = true }) => {
      let params = {
        wait: wait,
        api_url: 'externalmaintenance/index/simple',
        api_data_path: 'externalMaintenances',
        namespace: 'external_maintenance',
        query: 'search=' + encodeURIComponent(search),
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge des maintenances externes par identifiants : sert à réafficher la valeur d'un
     * formulaire en modification, dont la maintenance n'est pas forcément déjà dans le state.
     * @param   {array}   ids   Identifiants des maintenances externes
     * @param   {boolean} add   true pour compléter le state au lieu de le remplacer
     * @returns {promise}
     */
    getAllForSelectByIds: (context, { wait = false, ids, add = true }) => {
      if (!ids || !ids.length) {
        return Promise.resolve()
      }
      let params = {
        wait: wait,
        api_url: 'externalmaintenance/index/simple',
        api_data_path: 'externalMaintenances',
        namespace: 'external_maintenance',
        query: 'ids=' + ids.join(','),
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'externalmaintenance',
        namespace: 'external_maintenance',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item,) {
      return new Promise(function (resolve, reject) {
        let params = {
          api_url: 'externalmaintenance',
          namespace: 'external_maintenance',
          item: item
        }
        context.dispatch('addItem', params, {
          root: true
        }).then(response => {
          // Avant tout on demande au store Références de mettre à jour la référence associée
          // afin que la maintenance ajoutée apparaisse bien sur la page de détail
          // de la référence associée sur laquelle on est forcément.
          context.dispatch("reference/getItem", {
            id: item.reference_id
          }, {
            root: true
          });

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'externalmaintenance',
        namespace: 'external_maintenance',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'externalmaintenance',
        namespace: 'external_maintenance',
        id: id,
        ignoreGetAll: true
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/external_maintenance.js